import _ from 'lodash';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export function initI18n(cb) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(
      {
        fallbackLng: 'en',
        saveMissing: true,
        interpolation: {
          escapeValue: false,
        },
        whitelist: ['en', 'es'],
        load: 'all',
        react: {
          wait: true,
          bindI18n: 'languageChanged',
        },
      },
      () => {
        if (_.isFunction(cb)) cb();
      }
    );
}



// WEBPACK FOOTER //
// ./src/scripts/i18n/i18n.js